var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldhofer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "21px",
    viewBox: "0 0 54 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDE9Bicon/truck/golfhofer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(0.000000, 5.000000)",
    stroke: "#4F7CB4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-21",
    strokeWidth: 1.5,
    x: 1,
    y: 3,
    width: 34,
    height: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 5.5,
    x2: 7.5,
    y2: 7.5,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.5,
    y1: 5.5,
    x2: 14.5,
    y2: 7.5,
    id: "Line-Copy-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.5,
    y1: 5.5,
    x2: 21.5,
    y2: 7.5,
    id: "Line-Copy-3",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.5,
    y1: 5.5,
    x2: 28.5,
    y2: 7.5,
    id: "Line-Copy-4",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.5,
    y1: 2.75246334,
    x2: 35.5,
    y2: 7.5,
    id: "Line-Copy-5",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 2.75152063,
    x2: 0.5,
    y2: 7.5,
    id: "Line-Copy",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,-2.27373675e-13 L43.0416667,-2.27373675e-13 L46,4.23382881 L46,8.23382881 L38,8.23382881 L38,-2.27373675e-13 Z",
    id: "Combined-Shape",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-23",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    cx: 4,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-26",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    cx: 18,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-24",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    cx: 11,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-27",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    cx: 25,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-28",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    cx: 32,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-25",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    cx: 43,
    cy: 9,
    r: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldhofer);
export default __webpack_public_path__ + "static/media/goldhofer.8cc1188dc2884fa5401945b15108ace4.svg";
export { ForwardRef as ReactComponent };